const blockList = {
  survey: [
    "mode",
    "cookieName",
    "widthMode",
    "logo",
    "logoWidth",
    "logoHeight",
    "logoFit",
    "showPreviewBeforeComplete",
    "pagePrevText",
    "pageNextText",
    // "completeText",
    "previewText",
    "editText",
    "startSurveyText",
    "showNavigationButtons",
    "showPrevButton",
    "firstPageIsStarted",
    "goNextPageAutomatic",
    "showProgressBar",
    "progressBarType",
    "questionsOnPageMode",
    "questionTitleLocation",
    "questionDescriptionLocation",
    "showQuestionNumbers",
    "questionTitlePattern",
    "requiredText",
    "questionStartIndex",
    "questionErrorLocation",
    "focusFirstQuestionAutomatic",
    "questionsOrder",
    "maxTextLength",
    "maxOthersLength",
    "autoGrowComment",
    // "pages",
    "showPageTitles",
    "showPageNumbers",
    "clearInvisibleValues",
    "textUpdateMode",
    "sendResultOnPageNext",
    "storeOthersAsComment",
    "focusOnFirstError",
    "checkErrorsMode",
    "navigateToUrl",
    "navigateToUrlOnCondition",
    "completedHtmlOnCondition",
    "loadingHtml",
    "completedBeforeHtml",
    "showTimerPanel",
    "showTimerPanelMode",
    "calculatedValues",
    "triggers"
  ],
  text: [
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "size",
    "requiredErrorText",
    "validators",
    "maxLength",
    "defaultValue",
    "useDisplayValuesInTitle",
    "textUpdateMode",
    "autoComplete",
    "dataList",
    "correctAnswer",
    "valueName",
    "clearIfInvisible",
    "id",
    "readOnly",
  ],
  html: [
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "size",
    "requiredErrorText",
    "validators",
    "maxLength",
    "defaultValue",
    "useDisplayValuesInTitle",
    "textUpdateMode",
    "autoComplete",
    "dataList",
    "correctAnswer",
    "valueName",
    "clearIfInvisible",
    "id",
    "readOnly",
  ],
  page: [
    "maxTimeToFinish",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "questionsOrder",
    "navigationButtonsVisibility",
    "questionTitleLocation",
    "readOnly",
  ],
  checkbox: [
    "choicesByUrl",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "defaultValueExpression",
    "hideIfChoicesEmpty",
    "choicesVisibleIf",
    "choicesEnableIf",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "colCount",
    "requiredErrorText",
    "validators",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "useDisplayValuesInTitle",
    "id",
    "readOnly",
  ],
  radiogroup: [
    "choicesByUrl",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "hideIfChoicesEmpty",
    "choicesVisibleIf",
    "choicesEnableIf",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "colCount",
    "requiredErrorText",
    "validators",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "useDisplayValuesInTitle",
    "id",
    "readOnly",
  ],
  dropdown: [
    "autoComplete",
    "choicesByUrl",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "hideIfChoicesEmpty",
    "choicesVisibleIf",
    "choicesEnableIf",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "colCount",
    "requiredErrorText",
    "validators",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "useDisplayValuesInTitle",
    "id",
    "readOnly",
  ],
  comment: [
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "size",
    "requiredErrorText",
    "validators",
    "maxLength",
    "defaultValue",
    "useDisplayValuesInTitle",
    "textUpdateMode",
    "autoComplete",
    "dataList",
    "correctAnswer",
    "valueName",
    "clearIfInvisible",
    "id",
    "readOnly",
  ],
  rating: [
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "size",
    "requiredErrorText",
    "validators",
    "maxLength",
    "defaultValue",
    "useDisplayValuesInTitle",
    "textUpdateMode",
    "autoComplete",
    "dataList",
    "correctAnswer",
    "valueName",
    "clearIfInvisible",
    "id",
    "readOnly",
  ],
  ranking: [
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "size",
    "requiredErrorText",
    "validators",
    "maxLength",
    "defaultValue",
    "useDisplayValuesInTitle",
    "textUpdateMode",
    "autoComplete",
    "dataList",
    "correctAnswer",
    "valueName",
    "clearIfInvisible",
    "id",
    "readOnly",
  ],
  imagepicker: [
    "contentMode",
    "imageFit",
    "imageHeight",
    "imageWidth",
    "choicesByUrl",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "hideIfChoicesEmpty",
    "choicesVisibleIf",
    "choicesEnableIf",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "colCount",
    "requiredErrorText",
    "validators",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "useDisplayValuesInTitle",
    "id",
    "readOnly",
  ],
  boolean: [
    "label",
    "showTitle",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "useDisplayValuesInTitle",
    "valueTrue",
    "valueFalse",
    "requiredErrorText",
    "validators",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "id",
    "readOnly",
  ],
  signaturepad: [
    "width",
    "height",
    "dataFormat",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "minWidth",
    "maxWidth",
    "valueName",
    "useDisplayValuesInTitle",
    "requiredErrorText",
    "validators",
    "clearIfInvisible",
    // "title",
    "id",
    "readOnly",
  ],
  matrix: [
    //logic
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "columnsVisibleIf",
    "rowsVisibleIf",
    //logic
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "showHeader",
    "showColumnHeader",
    //validators
    "requiredErrorText",
    "validators",
    "isAllRowRequired",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "useDisplayValuesInTitle",
    "id",
    "readOnly",
  ],
  matrixdropdown: [
    //general
    "detailPanelMode",
    "totalText",
    //logic
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "columnsVisibleIf",
    "rowsVisibleIf",
    //layout
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "showHeader",
    "showColumnHeader",
    "columnLayout",
    "horizontalScroll",
    "columnColCount",
    "columnMinWidth",
    "rowTitleWidth",
    //validation
    "requiredErrorText",
    "validators",
    "keyDuplicationError",
    "valueName",
    "clearIfInvisible",
    "defaultValue",
    "correctAnswer",
    "useDisplayValuesInTitle",
    "id",
    "readOnly",
  ],
  email: [
    "description",
    "name",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "size",
    "requiredErrorText",
    "validators",
    "maxLength",
    "useDisplayValuesInTitle",
    "textUpdateMode",
    "autoComplete",
    "dataList",
    "correctAnswer",
    "valueName",
    "clearIfInvisible",
    "id",
    "readOnly",
  ],
  file: [
    "readOnly",
    // "hasComment",
    // "commentText",
    "commentPlaceHolder",
    // "allowMultiple",
    // "allowImagesPreview",
    "id",
    "acceptedTypes",
    "showPreview",
    "storeDataAsText",
    "maxSize",
    "imageHeight",
    "imageWidth",
    "waitForUpload",
    "needConfirmRemoveFile",
    "visibleIf",
    "enableIf",
    "requiredIf",
    "bindings",
    "defaultValueExpression",
    "page",
    "startWithNewLine",
    "hideNumber",
    "state",
    "titleLocation",
    "descriptionLocation",
    "indent",
    "width",
    "minWidth",
    "maxWidth",
    "valueName",
    "useDisplayValuesInTitle",
    "clearIfInvisible",
    "requiredErrorText"
  ]
};

export default blockList;
